import { Component, computed, inject, ViewEncapsulation, input, output } from '@angular/core';
import { SidebarNavigationComponent, type NavItem } from '@purolator/ui-kit-angular';
import { TranslationService } from '../../../core/i18n';

/**
 * Primary sidebar navigation for shipping workflows on desktop viewports.
 */
@Component({
  selector: 'app-shell-sidebar',
  imports: [SidebarNavigationComponent],
  templateUrl: './shell-sidebar.html',
  styleUrl: './shell-sidebar.scss',
  encapsulation: ViewEncapsulation.None,
  host: {
    class: 'app-shell__sidebar',
    role: 'complementary',
    '[attr.aria-label]': 'sidebarAriaLabel()',
  },
})
export class ShellSidebar {
  private readonly translation = inject(TranslationService);

  readonly items = input.required<NavItem[]>();
  /** Forwards puro-sidebar-navigation item ids so the shell can open external tools (OM-825). */
  readonly itemClick = output<string>();

  /** Accessible name for the complementary navigation landmark. */
  protected readonly sidebarAriaLabel = computed(() => {
    this.translation.revision();
    return this.translation.translate('layout.sidebar.ariaLabel');
  });

  /**
   * Relays a sidebar item selection to the application shell.
   * @param itemId Nav item id emitted by the kit sidebar.
   */
  protected onItemClick(itemId: string): void {
    this.itemClick.emit(itemId);
  }
}
